/* tslint:disable */

import { CMSResource } from "app/resources/cmsresource";
import { AppointmentResource } from "./AppointmentResource";
import { CMSListResourceSupport } from "./CMSListResourceSupport";


export class AppointmentListResource extends CMSListResourceSupport {

	appointmentList: AppointmentResource[]

}
